import React from 'react'
// libs
import moment from 'moment'
// utils
import { groupBy, isEmpty } from 'lodash'
// constants
import { ENTITIES, ACTION_AND_OBJECTIVES_ACTIVITIES_FILTERS, PLAN_AND_KPI_ACTIVITIES_FILTERS } from 'constants/index'
// types
import { LogActionTypes, LogEntityTypes } from 'types/graphql'

export const getSourceByActivity = (activity) => {
  let entity = {}

  if (activity.entityType === LogEntityTypes.Objective) {
    entity = activity.objective
  }
  if (activity.entityType === LogEntityTypes.Action) {
    entity = activity.action
  }
  if (activity.entityType === LogEntityTypes.Kpi) {
    entity = activity.kpi
  }

  return entity
}

export const sortActivitiesByDate = (data) => {
  if (isEmpty(data)) {
    return
  }

  const groupedLogs = groupBy(data, (item) => moment(item.createdAt).startOf('day').toISOString())
  return Object.entries(groupedLogs)
}

export const generateLogEntityType = (type) => {
  if (type === ENTITIES.PLAN_OBJECTIVE) {
    return LogEntityTypes.Objective
  }
  if (type === ENTITIES.PLAN_ACTION) {
    return LogEntityTypes.Action
  }
  if (type === ENTITIES.PLAN_KPI) {
    return LogEntityTypes.Kpi
  }
}

export const getOptionsForFilter = (entityType) => {
  if (entityType === LogEntityTypes.Plan || entityType === LogEntityTypes.Kpi) {
    return PLAN_AND_KPI_ACTIVITIES_FILTERS
  }
  if (entityType === LogEntityTypes.Objective || entityType === LogEntityTypes.Action) {
    return ACTION_AND_OBJECTIVES_ACTIVITIES_FILTERS
  }
}

export const generateFilterVariables = (filters, entity) => {
  let filter = {
    entityId: entity.id,
    actionType: [LogActionTypes.Create, LogActionTypes.Update, LogActionTypes.Delete]
  }

  const filterActionTypes = filters.filter((filter) => filter === LogActionTypes.Update)

  const filterEntityTypes = filters.filter((filter) => !filterActionTypes.some((actionType) => filter === actionType))

  if (!isEmpty(filterActionTypes)) {
    filter.actionType = [...filter.actionType]
    filter.entityType = [entity.entityType]
  }

  if (!isEmpty(filterEntityTypes)) {
    if (!isEmpty(filter.entityType)) {
      filter.entityType = [...filter.entityType, ...filterEntityTypes]
    } else {
      filter.entityType = filterEntityTypes
    }
  }

  if (isEmpty(filters)) {
    filter = {}
  }

  return filter
}

export const getActivityLabel = (activity) => {
  if (!activity) return

  if (activity.entityType === LogEntityTypes.Comment) {
    return 'Comment'
  }
  if (activity.entityType === LogEntityTypes.Resource) {
    return 'Resource'
  }
  return 'Attachment'
}

export const normalizeLink = (link) => {
  if (!link?.startsWith?.('http')) {
    return 'https://' + link
  }
  return link
}

export const getActivityContentType = (activity) => {
  if (activity.entityType === LogEntityTypes.Image) {
    return 'Attachment'
  }
  if (activity.entityType === LogEntityTypes.Link) {
    return 'Link'
  }
}
